import type { Assign } from '@ark-ui/react'
import { ark } from '@ark-ui/react'
import { forwardRef } from 'react'
import { Icon } from '~/components/icon'
import { cn } from '~/utils/cn'
import type { TIconProps } from '~/components/icon'
import type { InputTextSharedProps } from './input-text-root'

export type InputTextIconProps = Assign<
  React.ComponentProps<typeof ark.div>,
  InputTextSharedProps & {
    readOnly?: boolean
    disabled?: boolean
  }
> &
  Pick<TIconProps, 'symbol' | 'color'>

export const InputTextIcon = forwardRef<HTMLDivElement, InputTextIconProps>(
  (
    {
      color = 'colorTextNeutralDefault',
      symbol,
      size = 'ml',
      disabled,
      readOnly,
      ...props
    },
    ref
  ) => {
    const iconSize = (() => {
      const inputTextIconSizeMapper: Record<string, TIconProps['size']> = {
        md: 'extra-small',
        ml: 'small',
        lg: 'small',
        xl: 'small',
      }
      return inputTextIconSizeMapper?.[size]
    })()

    const iconColorMapping = (): TIconProps['color'] => {
      return disabled
        ? 'colorTextNeutralDisabled'
        : readOnly
          ? 'colorTextNeutralReadonly'
          : 'colorTextNeutralDefault'
    }

    return (
      <ark.div ref={ref} className="flex items-center" {...props}>
        <Icon symbol={symbol} color={iconColorMapping()} size={iconSize} />
      </ark.div>
    )
  }
)

InputTextIcon.displayName = 'InputTextIcon'
